import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CircularNavService {
  readonly hideNavBar$ = new BehaviorSubject(false);
}
